import React, { useEffect, useState, Fragment } from 'react'

import smiley100 from './../../images/smiley/smiley-100-percent.svg'
import smiley66 from './../../images/smiley/smiley-66-percent.svg'
import smiley33 from './../../images/smiley/smiley-33-percent.svg'
import smiley0 from './../../images/smiley/smiley-0-percent.svg'
import icons from './../../images/icons.svg'
import { sendConsumerResponse } from '../../api'
import { useTranslation } from 'react-i18next';

const Ratings = ({ receipt }) => {
    const { t } = useTranslation();
    const [chosenSmiley, setChosenSmiley] = useState()
    const [customerWishes, setCustomerWishes] = useState()
    const [currentPage, setCurrentPage] = useState(1);
    const pageTitles = {

        1: {
            title: t('rate_shopping'),
            buttonText: t('notNow'),
        },
        2: {
            title: t('leaveWishes'),
            buttonText: t('notNow'),
        },
        3: {
            title: t('responseThankYou'),
            buttonText: t('close'),
        }

    }
    const changePage = () => {
        const page = currentPage + 1
        setCurrentPage(page)
    }

    const submitRating = () => {
        const params = new URLSearchParams(window.location.search)
        const deviceCode = params.get('deviceCode')
        const timestamp = params.get('t')
        const orderId = receipt?.orderId;
        const ratingObj = {
            rating: chosenSmiley?.id,
            timestamp,
            wish: customerWishes,
            deviceCode,
            orderId
        }
        sendConsumerResponse(ratingObj)
        changePage();

    }


    useEffect(() => {
        if (chosenSmiley) {
            const params = new URLSearchParams(window.location.search)
            const deviceCode = params.get('deviceCode')
            const timestamp = params.get('t')
            const orderId = receipt?.orderId;
            const ratingObj = {
                rating: chosenSmiley?.id,
                deviceCode,
                timestamp,
                orderId
            }
            sendConsumerResponse(ratingObj)
            const page = currentPage + 1
            setCurrentPage(page)
        }
    }, chosenSmiley)

    const customerReacted = () => {
        return chosenSmiley || customerWishes
    }


    return (
        <div className='ratings'>
            <div className="ratings__container">
                {
                    currentPage !== 3 ? (
                        <div className="ratings__header">
                            {pageTitles[currentPage].title}
                        </div>
                    ) : (
                        <div className="ratings__thankyou animate__animated animate__fadeInRight">
                            <svg className="ratings__thankyou-icon">
                                <use xlinkHref={`${icons}#icon-checkmark`}></use>
                            </svg>
                            <div className="ratings__thankyou-text">
                                {customerReacted() ? pageTitles[currentPage].title : null}
                            </div>
                        </div>
                    )
                }

                {
                    currentPage === 1 && (
                        <div className="ratings__emotions">
                            <img className="ratings__emotions-img" src={smiley100} onClick={() => { setChosenSmiley({ id: 100, src: smiley100 }) }} />
                            <img className="ratings__emotions-img" src={smiley66} onClick={() => { setChosenSmiley({ id: 66, src: smiley66 }) }} />
                            <img className="ratings__emotions-img" src={smiley33} onClick={() => { setChosenSmiley({ id: 33, src: smiley33 }) }} />
                            <img className="ratings__emotions-img" src={smiley0} onClick={() => { setChosenSmiley({ id: 0, src: smiley0 }) }} />
                        </div>
                    )
                }

                {currentPage === 2 && (
                    <Fragment>
                        <FreeTextArea
                            textChange={(value) => setCustomerWishes(value)}
                            textValue={customerWishes}
                            submitRating={submitRating}
                        />
                    </Fragment>
                )}

                {
                    currentPage < 3 && (
                        <div className="ratings__send ratings__send--notnow" onClick={() => changePage()}>
                            <span>{pageTitles[currentPage].buttonText}</span>
                        </div>
                    )
                }


                {chosenSmiley && currentPage !== 3 &&
                    <div className="ratings__thankyou">
                        {chosenSmiley && <img className="ratings__thankyou-img" src={chosenSmiley.src} />}
                    </div>
                }
            </div>
        </div>
    )
}

const FreeTextArea = ({ textValue, textChange, submitRating }) => {
    const { t } = useTranslation();

    return (
        <div className="ratings__cta animate__animated animate__fadeInRight">
            <textarea
                className="ratings__textbox" rows="6"
                value={textValue}
                onChange={(event) => { textChange(event.target.value) }}
            />
            <div className={`ratings__send ${!textValue ? 'ratings__send--disabled' : ''}`} onClick={() => submitRating()}>
                <span>{t('send')}</span>
            </div>
        </div>
    )
}

export default Ratings
